
export class Referral {
    public jobPostingId: number = 0;
    public userFullName: string = '';
    public email: string = '';
    public phoneNbr: string = '';
    public referralCode: string = '';
    public companyCode: string = '';
    public referralType!:string;
    public referredJobLocation : string = '';
    public utmTrackerId!: number;
    public sourceChannelValue: string = 'Talent Portal';
}